import { render, staticRenderFns } from "./StoreData.vue?vue&type=template&id=e31432d4&scoped=true&lang=pug"
import script from "./StoreData.vue?vue&type=script&lang=js"
export * from "./StoreData.vue?vue&type=script&lang=js"
import style0 from "./StoreData.vue?vue&type=style&index=0&id=e31432d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31432d4",
  null
  
)

export default component.exports